import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { ESizeFrom, FORM_CONFIGS, SpinOptions } from '@framework/workbench/drawer/ui/layout/position/config';
import { IPositionFeature } from './position-interface';
import { Form, NumberInputFrom } from '@tencent/wb-ext-form';
import { FormItemName, IMultiDiffValue, INPUT_PROPS_CALLBACK_KEY } from '../../../constants';

@Controller({ formItems: FORM_CONFIGS })
export class PositionController {
    constructor(@Loader(IPositionFeature) private loader: IDynamicLoader<IPositionFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(FormItemName.HORIZONTAL_POSITION, 'value')
    public getHorizontalPosition(): number | IMultiDiffValue {
        const leftObj = { left: this.feature.left };
        const left = this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.POSITION, leftObj);
        return this.feature.modifyShownValue(left, SpinOptions.toFixed);
    }

    @Form(FormItemName.HORIZONTAL_POSITION, 'onChange')
    public changeHorizontalPosition(value: number, from: NumberInputFrom): void {
        const { left } = this.feature.getValidValue({ left: value }, from, SpinOptions.max, SpinOptions.min);
        this.feature.handleLeftChange(left, from);
    }

    @Form(FormItemName.VERTICAL_POSITION, 'value')
    public getVerticalPosition(): number | IMultiDiffValue {
        const topObj = { top: this.feature.top };
        const top = this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.POSITION, topObj);
        return this.feature.modifyShownValue(top, SpinOptions.toFixed);
    }

    @Form(FormItemName.VERTICAL_POSITION, 'onChange')
    public changeVerticalPosition(value: number, from: NumberInputFrom): void {
        const { top } = this.feature.getValidValue({ top: value }, from, SpinOptions.max, SpinOptions.min);
        this.feature.handleTopChange(top, from);
    }

    @Form(FormItemName.HORIZONTAL_FROM, 'value')
    public getHorizontalFrom(): string {
        return this.feature.horizontalFrom;
    }

    @Form(FormItemName.HORIZONTAL_FROM, 'onChange')
    public changeHorizontalFrom(value: ESizeFrom): void {
        this.feature.handleHorizontalFromChange(value);
    }

    @Form(FormItemName.VERTICAL_FROM, 'value')
    public getVerticalFrom(): string {
        return this.feature.verticalFrom;
    }

    @Form(FormItemName.VERTICAL_FROM, 'onChange')
    public changeVerticalFrom(value: ESizeFrom): void {
        this.feature.handleVerticalFromChange(value);
    }
}
